import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import api from '../apis/messageManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class MessageManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  @observable tabsValue='APIInformationSearch'
  @action
  changeTabsValue(value){
    this.tabsValue=value
  }
  @observable searchItem = {}
  @observable allMessageList = []
  @observable messageOverviewList = []

  /*overView tab 1*/
	@action
	async searchMessageOverview(params, pageNo, pageSize){
		this.isFetching = true
		this.messageOverviewList = []
    this.pageNo = pageNo;
    this.pageSize = pageSize;
		this.itemCount = 0
		try {
      const response = await api.searchMsgOverviewAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
				this.isFetching = false
				if(response.data.code === 0){
					if(response.data.data===null){
						alertMessage.error('Failed！ Data Platfrom no data!')
					}else {
						this.messageOverviewList = response.data.data?.records || []
						this.itemCount = response.data.data?.total
						this.searchItem = params
					}
				} else {
                  alertMessage.error(response.data.messageEn)
				}
      })
		} catch (error) {
			runInAction(() => {
				this.isFetching = false;
			});
		}
	}
  /*overView tab 2*/
  @action
  async searchMessageOverviewIdentification(params, pageNo, pageSize){
    this.isFetching = true
    this.messageOverviewList = []
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      const response = await api.searchMsgOverviewIdentificationAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if(response.data.code === 0){
          if(response.data.data===null){
            alertMessage.error('Failed！ Data Platfrom no data!')
          }else {
            this.messageOverviewList = response.data.data?.records || []
            // this.messageOverviewList = this.allMessageList.slice(0,this.pageSize)
            this.itemCount = response.data.data?.total
            this.searchItem = params
          }
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (error) {
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*overView tab 3*/
  @action
  async searchMessageOverviewIndex(params, pageNo, pageSize){
    this.isFetching = true
    this.messageOverviewList = []
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      const response = await api.searchMsgOverviewIndexAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if(response.data.code === 0){
          if(response.data.data===null){
            alertMessage.error('Failed！ Data Platfrom no data!')
          }else {
            this.messageOverviewList = response.data.data?.records || []
            // this.messageOverviewList = this.allMessageList.slice(0,this.pageSize)
            this.itemCount = response.data.data?.total
            this.searchItem = params
          }
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (error) {
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*overView indexNames*/
  @observable indexNames=[]
  @action
  async searchMsgOverviewIndexName(params){
    this.indexNames = []
    try {
      const response = await api.searchMsgOverviewIndexNameAction(params)
      runInAction(() => {
        if(response.data.code === 0){
          if(response.data.data===null){
            alertMessage.error('Failed！ Data Platfrom no data!')
          }else {
            var indexNameList = []
            var indexNameGroupList = []
            response.data.data.indexManagementList.map(item=> indexNameList.push(item.indexName))
            response.data.data.indexManagementGroupList.map(item=> indexNameList.push(item.groupName))
            this.indexNames = indexNameList.concat(indexNameGroupList).sort() || []
          }
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (error) {
      runInAction(() => {
      });
    }
  }
  /*page*/
  @action
  onChangePageNumAction(pageNo, pageSize) {
		if (this.pageIndex !== pageNo || pageSize !== this.pageSize) {
      runInAction(() => {
        this.pageNo = pageNo
        this.pageSize = pageSize || this.pageSize
      })
          if(this.tabsValue==='APIInformationSearch') {
            this.searchMessageOverview(this.searchItem,this.pageNo,this.pageSize)	// 接口不提供分页，前端自己分页
          }else if(this.tabsValue==='identificationSearch') {
            this.searchMessageOverviewIdentification(this.searchItem,this.pageNo,this.pageSize)	// 接口不提供分页，前端自己分页
          }else {
            this.searchMessageOverviewIndex(this.searchItem,this.pageNo,this.pageSize)	// 接口不提供分页，前端自己分页
          }
    }
  }
  @action
  onChangePageNo(pageNo,pageSize) {
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.messageOverviewList = this.allMessageList.slice((pageNo-1)*pageSize,pageNo*pageSize)
  }

  @action
  resetOverviewList(){
    this.messageOverviewList=[]
  }
}
